const normalizeText = (text) => typeof text === "string" ? text.toLocaleLowerCase().trim() : "";
const isPartOfText = (value, text) => normalizeText(text).includes(normalizeText(value !== null && value !== void 0 ? value : ""));
const getMatchingValuesFromList = (value, list) => list.filter((listItem) => isPartOfText(value, listItem.label));
const getFirstValueStartingWith = (text, list) => {
    return list.find((listItem) => normalizeText(listItem.label).startsWith(text.toLocaleLowerCase()));
};
const getFilteredOptionsId = (comboboxId) => `${comboboxId}-filtered-options`;
const getOptionId = (comboboxId, option) => `${comboboxId.toLocaleLowerCase()}-option-${option
    .replace(" ", "-")
    .toLocaleLowerCase()}`;
const getAddNewOptionId = (comboboxId) => `${comboboxId}-combobox-new-option`;
const getIsLoadingId = (comboboxId) => `${comboboxId}-is-loading`;
const getNoHitsId = (comboboxId) => `${comboboxId}-no-hits`;
const getMaxSelectedOptionsId = (comboboxId) => `${comboboxId}-max-selected-options`;
export default {
    normalizeText,
    isPartOfText,
    getMatchingValuesFromList,
    getFilteredOptionsId,
    getAddNewOptionId,
    getOptionId,
    getIsLoadingId,
    getNoHitsId,
    getMaxSelectedOptionsId,
    getFirstValueStartingWith,
};
//# sourceMappingURL=filtered-options-util.js.map